module.exports = __webpack_public_path__ + "static/slide-3-f81a0f374152896ce94ccd5d4a93be3c.png";